export default __webpack_public_path__ + "static/media/mitigation-open-space-cleanout.5e63e672.jpg";